import * as Yup from 'yup';

export const initialValues = {
  amount: '',
};

export const getValidationSchema = (maxAmount?: number) =>
  Yup.object().shape({
    amount: Yup.number()
      .required()
      .positive()
      .max(maxAmount ?? 0),
  });
